import { jsx as _jsx } from "react/jsx-runtime";
import { createElement } from 'react';
import { RenderLeafFallback } from './RenderLeafFallback';
import { useRichTextRenderMetadata } from './RichTextRenderMetadataContext';
export function LeafRenderer({ leaf, renderLeaf, }) {
    const formatVersion = useRichTextRenderMetadata().formatVersion;
    const fallback = _jsx(RenderLeafFallback, { leaf: leaf }, void 0);
    return renderLeaf
        ? createElement(renderLeaf, {
            formatVersion,
            leaf,
            fallback,
        }, leaf.text)
        : fallback;
}
//# sourceMappingURL=LeafRenderer.js.map